import { action, observable, makeObservable } from 'mobx';
import { LinkOrderLineForm } from 'modules/order/forms';
import { BaseViewStore } from 'core/stores';
import { formInvalidate } from 'core/utils';
import { OrderLineStore } from 'modules/order-line/stores';
import { ProductService } from 'common/data';
import { ConfirmModalParams } from 'core/models';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class LinkOrderLineViewStore extends BaseViewStore {
	@observable existingProduct = false;
	@observable error = null;
	orderLine;

	form = new LinkOrderLineForm({
		onSuccess: async () => {
			this.openLinkOrderLineConfirmModal();
		},
	});

	constructor(rootStore, { refreshPage, parentViewStore }) {
		super(rootStore);
		makeObservable(this);
		this.parentView = rootStore.marketplaceOrderDetailViewStore.orderLinesListViewStore;
		this.orderLineStore = new OrderLineStore(rootStore);
		this.productService = new ProductService(rootStore.app.baasic.apiClient);
		this.refreshPage = refreshPage;
		this.initialize(parentViewStore);
	}

	@action.bound
	initialize = async parentViewStore => {
		this.suspend();
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		await this.getOrderLine(parentViewStore.linkOrderLineModal.data.id);
		this.resume();
	};

	@action.bound
	getOrderLine = async id => {
		this.orderLine = await this.orderLineStore.getOrderLine(id, {
			embed: ['order', 'order.channel', 'order.channel.channelType'],
		});
	};

	@action.bound
	linkOrderLine = async linkAll => {
		this.suspend();
		try {
			const { product, description } = this.form.values();
			await this.orderLineStore.linkOrderLine(
				{
					id: this.orderLine.id,
					productId: product.extra.id,
					linkAll,
					description,
				},
				linkAll ? sourceOfChange.linkAllOrderLines : sourceOfChange.linkOrderLine
			);
			this.rootStore.notificationStore.success(['LINKORDERLINEVIEW.ORDERLINELINKED']);
			this.parentView.closeModal();
			this.rootStore.viewStore.countUnlinkedOrderLines();
			this.refreshPage();
		} catch (err) {
			if (err.data != null) {
				this.error = ['LINKORDERLINEVIEW.ERROR', { sku: err.data.mainSku }];
			} else {
				formInvalidate({ form: this.form, err });
			}
			this.linkOrderLineConfirmModal.close();
		}
		this.resume();
	};

	@action.bound
	openLinkOrderLineConfirmModal() {
		this.linkOrderLineConfirmModal.open({
			message: ['LINKORDERLINEVIEW.LINKALLORDERLINES'],
		});
	}

	@action.bound
	toggleExistingProduct = () => {
		this.existingProduct = !this.existingProduct;
	};

	@action.bound
	onSelect = product => {
		if (product && product.value) {
			this.selectedProduct = product;
			this.form.$('productSku').value = product.value;
		}
	};

	linkOrderLineConfirmModal = new ConfirmModalParams({
		onConfirm: async () => {
			await this.linkOrderLine(true);
		},
		onCancel: async () => {
			await this.linkOrderLine(false);
		},
	});
}

export default LinkOrderLineViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/LinkOrderLineViewStore.js